import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { StateColorScheme } from './types'

const initialState: StateColorScheme = {
  colorScheme: null,
}

export const sliceColorScheme = createSlice({
  initialState,
  name: 'colorScheme',
  reducers: {
    setColorScheme: (state, { payload }: PayloadAction<StateColorScheme>) => {
      state.colorScheme = payload.colorScheme
    },
  },
})
export const { setColorScheme } = sliceColorScheme.actions
